import { useEffect, useRef, useState } from "react";
import { animate, useInView } from "framer-motion";
import { Reveal } from "./Reveal";

export const Stat = ({ value, suffix = "", label, testid, delay = 0 }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [display, setDisplay] = useState(0);

  useEffect(() => {
    if (!inView) return;
    const controls = animate(0, value, {
      duration: 1.8,
      ease: [0.22, 1, 0.36, 1],
      onUpdate: (v) => setDisplay(Math.round(v)),
    });
    return () => controls.stop();
  }, [inView, value]);

  return (
    <Reveal delay={delay}>
      <div ref={ref} data-testid={testid} className="border-l-2 border-das-violet pl-5">
        <div className="font-display text-5xl font-bold tracking-tight text-das-ink sm:text-6xl">
          {display}
          <span className="text-das-violet">{suffix}</span>
        </div>
        <p className="mt-2 text-sm font-semibold uppercase tracking-[0.18em] text-neutral-500">
          {label}
        </p>
      </div>
    </Reveal>
  );
};
